import { render } from "./DeleteIcon.vue?vue&type=template&id=4ee329dc&scoped=true"
import script from "./DeleteIcon.vue?vue&type=script&lang=js"
export * from "./DeleteIcon.vue?vue&type=script&lang=js"

import "./DeleteIcon.vue?vue&type=style&index=0&id=4ee329dc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ee329dc"]])

export default __exports__